module.exports = __webpack_public_path__ + "static/media/punisher.9d3e9751.png";